/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2024
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import Enum from './Enum';
//@import Enum (loadtime) // superclass

/**
 * <p>Java class for sortOrder. <p>The following schema fragment specifies the expected content contained within this class. <p> <pre> &lt;simpleType name="sortOrder"&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}NMTOKEN"&gt; &lt;enumeration value="ascending"/&gt; &lt;enumeration value="descending"/&gt; &lt;/restriction&gt; &lt;/simpleType&gt; </pre>
 */
export default class SortOrder extends Enum{

	enumValue = null;

	static  ASCENDING = SortOrder.newLiteral("ascending");

	static  DESCENDING = SortOrder.newLiteral("descending");



	constructor(v) {
		super(v);
		this.enumValue = v;
	}

	static fromValue(v) {
		for (var i = 0; (i < SortOrder.values().length); ++i) {
			if (SortOrder.values()[i].enumValue == v) {
				return SortOrder.values()[i];
			}
		}
		throw new Error(v);
	}

	value() {
		return this.enumValue;
	}

	getResourceId() {
		return (("SortOrder" + "_") + this.value());
	}
}


// WEBPACK FOOTER //
// ./src/generated/SortOrder.js